<template>
  <ElDialog
    class="employee-modal"
    :model-value="modelValue"
    width="1158px"
    :title="$t('User.ClinicEmployee')"
    v-bind="$attrs"
    @update:model-value="$emit('update:modelValue', $event)">
    <div v-if="loading.getData" v-loading="true" />
    <VeeForm as="ElForm">
      <EmployeeForm
        v-if="!!formData.values"
        :is-show-edit-button="isShowEditButton"
        :is-disabled="isDisabled"
        :form-data="formData.values"
        @is-disabled-false="isDisabled = false"
        @close:modal="$emit('update:modelValue')"
        @action="$emit('action', $event)" />
    </VeeForm>
  </ElDialog>
</template>

<script lang="ts">
export default {
  name: 'EmployeeModal',
  inheritAttrs: false,
  customOptions: {},
};
</script>

<script setup lang="ts">
import { Form as VeeForm } from 'vee-validate';
import { reactive, ref, watch } from 'vue';

import { EmployeeFormData, User } from '@/models/User.model';
import { EmployeeDto } from '@/types/api';
import EmployeeForm from '@/components/accounting/modals/EmployeeModal/EmployeeForm/index.vue';

defineEmits(['update:modelValue', 'action']);

const props = withDefaults(
  defineProps<{ modelValue: boolean; userId: number | null; userUuid: string | null }>(),
  {
    modelValue: false,
    userId: null,
    userUuid: null,
  }
);

const loading = reactive({
  getData: false,
});

const formData = reactive<{ values: null | EmployeeFormData }>({
  values: null,
});

const isShowEditButton = ref(false);

const isDisabled = ref(false);

const getUserById = async (uuid: string) => {
  loading.getData = true;
  const response = await User.findOneById<EmployeeDto>(uuid);
  formData.values = { ...new User(response.data.data), uuid };
  loading.getData = false;
};

watch(
  () => props.userUuid,
  (value) => {
    if (value) {
      isShowEditButton.value = true;
      isDisabled.value = true;
      getUserById(value);
    } else {
      formData.values = { ...new User(), uuid: value ?? '' };
    }
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped></style>
